import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageMovementTable extends Layout {
	panelSecondaryFilters: Panel;
	sourceBrokerageMovements: DataSource;
	sourceMovement: DataSource;
	tableMovements: Table;
}
